import React, { useEffect, useState } from "react";
import CTA from "./CTA";
import HeaderSocial from "./HeaderSocials";
import profilePic from "../../assets/profilepic.jpeg";
import { useMouseGlow } from "../../hooks/useMouseGlow";
import { useTypingAnimation } from "../../hooks/useTypingAnimation";
import { getProfileConfig } from "../../firebase";
import { defaultProfile } from "../../data/defaultPortfolioData";
import "./header.css";

const Header = () => {
  const { elementRef, glowRef } = useMouseGlow();
  const [profile, setProfile] = useState(defaultProfile)
  const summaryText = profile.summary;
  const typedSummary = useTypingAnimation(summaryText, 30, 500);

  useEffect(() => {
    let isMounted = true

    getProfileConfig().then((remoteProfile) => {
      if (isMounted) {
        setProfile(remoteProfile)
      }
    })

    return () => {
      isMounted = false
    }
  }, [])

  return (
    <header id="home" className="card-container">
      <div className="container header__container">
        {/* <h5>Hello I'm</h5> */}
        <h1>{profile.name}</h1>
        <h5 className="text-light">{profile.subtitle}</h5>
        <p className="header__summary">
          {typedSummary}
          <span className="typing-cursor">|</span>
        </p>
        <CTA resumeUrl={profile.resumeUrl} />
        <HeaderSocial links={profile.links} />
        <section>
          <div className="wrapper" ref={elementRef}>
            <div className="glow" ref={glowRef}></div>
            <img src={profilePic} className="box" alt="Tejas Patne" />
          </div>
        </section>

        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
